import { Fragment, useState, useEffect, useRef } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ClientDropdown(data) {
    const [selected, setSelected] = useState(JSON.parse(window.localStorage.getItem("currentClient")))
    const clients = data.data
    const [search, setSearch] = useState("")
    const [filteredClients, setFilteredClients] = useState(clients)

    const inputRef = useRef(null)

    function notifyChange(client){
        setSelected(client)
        data.parentNotify(client)
    }

useEffect(() => {
  if (search === "") {
    setFilteredClients(clients)
  } else {
    const lowered = search.toLowerCase()
    setFilteredClients(
      clients.filter(c =>
        (c.name || "").toLowerCase().includes(lowered) ||
        (c.corporateId || "").toLowerCase().includes(lowered)
      )
    )
  }
}, [search, clients])



  return (
    <Listbox value={selected} onChange={notifyChange} disabled={clients.length==1}>
      {({ open }) => (
        <>
          <div className="relative">
            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-black-500 sm:text-sm sm:leading-6">
              <span className="inline-flex w-full truncate">
                <span className="truncate">{selected.name}</span>
                <span className="ml-2 truncate text-gray-500">{selected.corporateId}</span>
              </span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-96 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm border-2">
                
                <div className="p-2 border-b">
                 <input
  ref={inputRef}
  type="text"
  className="w-full rounded-md border px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
    placeholder="Sök..."
  value={search}
  onChange={(e) => setSearch(e.target.value)}
  onKeyDown={(e) => e.stopPropagation()}
/>

                </div>

                {filteredClients.length === 0 && (
                  <div className="px-4 py-2 text-gray-400 italic">
                    Inga träffar
                  </div>
                )}

                {filteredClients.map((client) => (
                  <Listbox.Option
                    key={client.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-indigo-600 text-white' : 'text-gray-900',
                        'relative cursor-default select-none py-2 pl-3 pr-9'
                      )
                    }
                    value={client}
                  >
                    {({ selected, active }) => (
                      <>
                        <div className="flex flex-col">
                          <span className={classNames(selected ? 'font-extrabold' : 'font-bold', 'truncate')}>
                            {client.name}
                          </span>
                          <span className={classNames(active ? 'text-indigo-200' : 'text-gray-500', 'ml-2 truncate')}>
                            {client.corporateId}
                          </span>
                        </div>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? 'text-white' : 'text-indigo-600',
                              'absolute inset-y-0 right-0 flex items-center pr-4'
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}
